import { render, staticRenderFns } from "./MoveToFolder.vue?vue&type=template&id=0b93c562&scoped=true"
import script from "./MoveToFolder.vue?vue&type=script&lang=js"
export * from "./MoveToFolder.vue?vue&type=script&lang=js"
import style0 from "./MoveToFolder.vue?vue&type=style&index=0&id=0b93c562&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b93c562",
  null
  
)

export default component.exports